<template>
    <div class="">
        <div class="seachBox">
          <div class="seachList"><span class="name">客户名称：</span>
            <a-input placeholder=" " class="seachs" v-model="search.company"/>
          </div>
          <div class="seachList">
            <span class="name">网站类型：</span>
            <a-select v-model="search.site_type" placeholder="请选择" class="seachs" allowClear   >
              <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.site_type_list">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>
            <div class="seachList">
                <span class="name">上线状态：</span>
                <a-select v-model="search.online_status" placeholder="请选择" class="seachs" allowClear   >
                    <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.online_status">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
<!--          @change="(date,dateString) => onChangeTime(date,dateString,'statistics_date')"-->
            <div class="seachList">
                <span class="name">统计日期：</span>
                <a-range-picker class="seachs seachs-time"
                v-model="search.statistics_date" :disabledDate="disabledDate" allowClear :showTime="false" format="YYYY-MM-DD" />
            </div>
          <div class="seachList" style="padding-left: 20px">
            <a-button type="primary" class="top_btn" @click="getList()">搜索</a-button>
            <a-button   class="top_btn" @click="empty">重置</a-button>
          </div>
        </div>
      <p>阶段使用金额合计 <span style="color: #1890ff">{{statistics_total_price}}</span> 美元</p>
        <div class="flex" >
            <div><a-button class="top_btn" type="primary"   @click="exportList()"  >
                批量导出
            </a-button>
                <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template></span></div>

        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" >

        </a-table>

    </div>

</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    // sorter: true,

    const fdate=()=>{
      let nowdate = new Date();
      let y = nowdate.getFullYear();
      let m = nowdate.getMonth()+1;
      let d = nowdate.getDate();
      return   y+'-'+m+'-'+d;
    }
    const nowdate=()=>{
      let nowdate = new Date();
      nowdate.setMonth(nowdate.getMonth()-1);
      let y = nowdate.getFullYear();
      let m = nowdate.getMonth()+1;
      let d = nowdate.getDate();
      return   y+'-'+m+'-'+d;
    }
    const columns = [

        {
            title: "客户名称",
            key: "company",
            width:"150px",
            ellipsis: true,
            dataIndex: "company",
        },
        {
            title: "上线日期",
            key: "online_time",
            ellipsis: true,
            dataIndex: "online_time",

        },
        {
            title: "网站类型",
            key: "site_type_name",
            ellipsis: true,
            dataIndex: "site_type_name",
        },
        {
            title: "输入量/金额",
            key: "prompt_tokens_and_price",
            ellipsis: true,
            dataIndex: "prompt_tokens_and_price",
          scopedSlots: {customRender: "prompt_tokens_and_price"}
        },
        {
            title: "输出量/金额",
            key: "completion_tokens_and_price",
            ellipsis: true,
            dataIndex: "completion_tokens_and_price",
        },
      {
        title: "总量/总金额",
        key: "total_tokens_and_price",
        ellipsis: true,
        dataIndex: "total_tokens_and_price",
        sorter: true,
      }
    ];
    export default {
        name: 'index',
        data() {

            return {
              disabledDate(current) {
                // return current && current <moment().subtract(1,"days");//当天之前的不可选，不包括当天
               return current && current > moment().endOf('day');

              },
              statistics_total_price:'',
                loading: true,
                data: [],
                selectedRowKeys: [], // Check here to configure the default column
                columns,
                statistics_date:[],
                search: {
                  online_status: "",
                  site_type:'',
                  company:'',
                  statistics_date:[],
                },
                seachList:{
                  online_status:[],
                  site_type_list:[]
                },
              pagination: {
                pageNo: 1,
                pageSize: 20, // 默认每页显示数量
                onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                // onChange: this.getList.bind(this), //点击页码事件
                total: 0, //总条数
                current: 0,
                size: "small",
                showTotal: total => `共 ${total} 条`,
                showQuickJumper: true
              },
                // pagination: {
                //     pageNo: 1,
                //     pageSize: 20, // 默认每页显示数量
                //     onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                //     onChange: this.getList.bind(this), //点击页码事件
                //     total: 0, //总条数
                //     current: 0,
                //     size: "small",
                //     showTotal: total => `共 ${total} 条`,
                //     showQuickJumper: true
                // },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/Aichat"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
          statisticsDate(){
              let dataArr=[]
            if (this.statistics_date.length > 0) {
              dataArr[0] = moment(this.statistics_date[0]).format('YYYY-MM-DD')
              dataArr[1] = moment(this.statistics_date[1]).format('YYYY-MM-DD')
            }
            return dataArr
          },

        },

        methods: {
          moment,
          empty(){
                this.search.online_status=""
                this.search.site_type='',
                this.search.company=''
                this.search.statistics_date=[]
                this.seachList = {
                  online_status:[],
                  site_type_list:[]
                }
                this.getList()
            },
            handleChange(pagination, filters, sorter) {
            console.log("pagination",pagination)
              console.log("filters",filters)
              console.log("sorter",sorter)
                if(sorter.order) {
                  let sort=sorter.order=="ascend"?"1":"2"
                  this.search.total_tokens_order=sort
                }else{
                    // delete this.search.order_field
                    // delete this.search.order_sort
                       delete this.search.total_tokens_order
                }
                if (this.search.statistics_date.length > 0) {
                  this.search.statistics_date[0] = moment(this.search.statistics_date[0]).format('YYYY-MM-DD')
                  this.search.statistics_date[1] = moment(this.search.statistics_date[1]).format('YYYY-MM-DD')
                }
                let seachData = JSON.parse(JSON.stringify(this.search))
                API.service.GET_LIST({page:  pagination.current|| 1, ...seachData}).then(res => {
                  this.data = res.data.data.info.data
                  this.seachList.online_status = res.data.data.online_status
                  this.seachList.site_type_list = res.data.data.site_type_list
                  this.page=pagination.current || 1
                  this.pagination.total=res.data.data.info.total
                  this.pagination.pageSize=res.data.data.info.per_page
                  this.pagination.current=res.data.data.info.current_page
                  this.selectedRowKeys=[]
                  this.loading = false
                })
              },
            exportList(){
              if (this.search.statistics_date.length > 0) {
                this.search.statistics_date[0] = moment(this.search.statistics_date[0]).format('YYYY-MM-DD')
                this.search.statistics_date[1] = moment(this.search.statistics_date[1]).format('YYYY-MM-DD')
              }
                let seachData = JSON.parse(JSON.stringify(this.search))
                API.service.EXPORT({...seachData ,ids:this.selectedRowKeys }).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                })
            },
            getList(page) {
              this.loading = true
              if (this.search.statistics_date.length > 0) {
                this.search.statistics_date[0] = moment(this.search.statistics_date[0]).format('YYYY-MM-DD')
                this.search.statistics_date[1] = moment(this.search.statistics_date[1]).format('YYYY-MM-DD')
              }
                let seachData = JSON.parse(JSON.stringify(this.search))
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.info.data
                    this.statistics_total_price=res.data.data.statistics_total_price
                    this.seachList.online_status = res.data.data.online_status
                  this.seachList.site_type_list = res.data.data.site_type_list
                  this.page=page || 1
                    this.pagination.total=res.data.data.info.total
                    this.pagination.pageSize=res.data.data.info.per_page
                    this.pagination.current=res.data.data.info.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },
            // getBtnGroup(){
            //     API.service.GET_BTN().then(res=>{
            //         this.seachList.groupList = res.data.data.group
            //     })
            // },
            // getBtnList(value){
            //     let group_id = value;
            //     this.seachList.btnList=[]
            //     this.search.btn_id = undefined
            //     API.service.GET_BTN({'group_id':group_id}).then(res=>{
            //         this.seachList.btnList = res.data.data.btn
            //     })
            // },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            onChangeTime(date, dateString ,type) {
                this.type = date
                dateString[0] = moment(dateString[0]).format('YYYY-MM-DD')
                dateString[1] = moment(dateString[1]).format('YYYY-MM-DD')
                let dateStrings=`${dateString[0]}~${dateString[1]}`
                if(dateString[0] == 'Invalid date'){
                    dateStrings = ""
                }
                this.search[type] = dateStrings
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
        },
        mounted() {
          this.statistics_date=[nowdate(),fdate()]
          this.search["statistics_date"] = [nowdate(),fdate()]
          this.getList()
            // this.getBtnGroup()

        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .ant-input {
        width: 200px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .top .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 60%;margin-bottom: 20px}
    .seachBox{display: flex;}
    .seachBox .seachList{flex-wrap: nowrap;display: flex;width:20%; margin: 5px 0;}
    /*.seachs-time{min-width: 220px;}*/
    .seachBox .seachList .name{white-space:nowrap;}
</style>
